import { defineStore } from 'pinia'

export const useAppMetadataStore = defineStore('appMetadata', {
  state: () => ({
    backend_env: null,
  }),    
  actions: {
    setBackendEnv(value){
        this.backend_env = value
      }
  }
})
